import * as React from "react";
import { IHeaderState } from "source/app/presentation/Header/Header";
import { DeepWorkKipsTodayState } from "source/app/presentation/Header/Tools/DeepWorkKipsToday/DeepWorkKipsToday";
import { PostBookOfMindPointAsync } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/ChildNodeName/CompleteNode/PostBookOfMindPointAsync";
import { IWorkflowNode } from "../../../../../../motw_core/Entity/IWorkflowNode";
import Data from "../../Data";
import MotwLogicServer from "../../External/LogicServer/MotwLogicServer";
import RenderSwal from "../../Shared/RenderSwal/RenderSwal";
import { Sounds } from "../../Sound/Sounds";
import { BannerImages } from "../../Shared/RenderSwal/BannerImage/BannerImage";
import { ETexture } from "../../UI/Background/Texture/ETexture";
import { Texture } from "../../UI/Background/Texture/Texture";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export async function AwardBookOfMindPointAsync(newNode: IWorkflowNode) {
    const isBookOfMindQuote = await MotwLogicServer.GetIsQuotable(newNode.id);

    if (isBookOfMindQuote.data) {
        await PostBookOfMindPointAsync();

        // A new quote was added, so rebuild the server-side related-quotes
        // index in the background to include it. Fire-and-forget; never blocks.
        MotwLogicServer.RefreshBookOfMindRelatedQuotes().catch(() => {
            // Best-effort refresh; ignore failures.
        });

        ShowNewQuoteInfo();
        Sounds.shoutWhoo.Play();
        Data.Load.Single.ByStateTarget<DeepWorkKipsTodayState>(`kipsDTO`);
        Data.Load.Single.ByStateTarget<IHeaderState>("lifetimeKipsEarned");
    }
}

function ShowNewQuoteInfo() {
    const ToRender = () => (
        <div
            className={StyleClassAuto({
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                textAlign: "center",
                width: "90%",
                marginLeft: "7px",
                WebkitTransform: "translateY(-50%)",
                fontFamily: '"IM Fell French Canon SC"',
                fontSize: "24px",
                color: `white`,
                textShadow: "0px 0px 15px gold",
                paddingBottom: "15px",
            })}
        >
            <div>New</div>
            <div>Book of Mind</div>
            <div>quote</div>
            <div>discovered!</div>
        </div>
    );

    RenderSwal(
        {
            bannerImage: BannerImages.waxTablet,
            background: new Texture({
                image: ETexture.groovepaper,
                backgroundColor: { h: 36, s: 6, l: 8, a: 1 },
            }).combinedCSS.background as string,
            columnCount: 1,
            height: `125px`,
            timer: 2000,
        },
        <ToRender />
    );
}
